import { createUseStyles } from "react-jss";
import { theme } from "$utils/theme/bataillog";

export const useStyles = createUseStyles(() => ({
  wrapper: {
    maxWidth: "1200px",
  },
  ordersSelectBlock: {
    display: "flex",
    flexDirection: "column",
    marginTop: theme.spacing(1),
  },
}));
